import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { MaxBrainTag } from './tag.model';

export class TagStateModel extends EntityStateModel<MaxBrainTag> {}
